import { useEffect, useMemo, useState } from "react";
import { CategoryScale, Chart as ChartJS, LineElement, LinearScale, PointElement, Tooltip } from "chart.js";
import { Line } from "react-chartjs-2";
import { getWeeklyControlsEvolution } from "../api";
import { useAuth } from "../auth/AuthProvider";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

function ControlsEvolutionMiniChart() {
    const { withAuth } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                setLoading(true);
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
                const data = await withAuth((token) => getWeeklyControlsEvolution(token, timezone));
                if (!cancelled) {
                    setItems(data?.items || []);
                }
            } catch {
                if (!cancelled) {
                    setItems([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        load();

        return () => {
            cancelled = true;
        };
    }, [withAuth]);

    const data = useMemo(() => ({
        labels: items.map((item) => item.day),
        datasets: [
            {
                data: items.map((item) => Number(item.controls_count || 0)),
                borderColor: "#0d6efd",
                pointBackgroundColor: "#0d6efd",
                pointBorderColor: "#0d6efd",
                pointRadius: 2,
                pointHoverRadius: 2,
                borderWidth: 2,
                tension: 0.35,
                fill: false
            }
        ]
    }), [items]);

    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        animation: true,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true }
        },
        scales: {
            x: {
                display: false,
                grid: { display: false },
                border: { display: false }
            },
            y: {
                display: true,
                beginAtZero: true,
                ticks: {
                    precision: 0,
                    color: "#6c757d",
                    font: { size: 10 }
                },
                grid: {
                    color: "rgba(108, 117, 125, 0.2)",
                    drawBorder: false
                },
                border: { display: false }
            }
        },
        elements: {
            line: {
                borderCapStyle: "round",
                borderJoinStyle: "round"
            }
        }
    }), []);

    if (loading) {
        return <div className="text-secondary small">Chargement...</div>;
    }

    return (
        <div>
            <div className="text-secondary small mb-1 border-bottom pb-1 mb-1">Contrôles sur 7 jours</div>
            <div style={{ height: 90 }}>
                <Line data={data} options={options} />
            </div>
        </div>
    );
}

export default ControlsEvolutionMiniChart;
